import { CommonService } from './../page/common.service';
import { LateralPanelService } from '../page/lateral-panel/lateral-panel.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TooltipTypesEnum } from '../shared/tooltip-types.enum';
import { AnalyticsLibraryService } from '../analytics-library.service';

@Component({
  selector: "app-selector",
  templateUrl: "./selector.component.html",
  styleUrls: ["./selector.component.scss", "./selector.component.responsive.scss"]
})
export class SelectorComponent implements OnInit, OnChanges {
  @Input() id: number;
  @Input() name: string;
  @Input() image: string = undefined;
  @Input() imageClassFromFrontEnd: string = undefined;
  @Input() description: string;
  @Input() showDescription: boolean = false;
  @Input() showNameUnderDescription: boolean = false;
  @Input() tooltip: string;
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() lateralPanelId: string;
  @Input() showInfo: boolean;
  @Input() buildShadow: boolean = true;
  @Input() isFirst: boolean = false;
  @Input() isLast: boolean = false;
  @Input() isSingleItem: boolean = true;
  @Input() tooltipType: TooltipTypesEnum = null;
  @Input() checkbox: boolean = false;
  @Input() isHoveringIco: boolean = false;

  @Output() selected = new EventEmitter();
  @Output() infoRequested = new EventEmitter();
  @Output() infoClicked = new EventEmitter();

  state = "deselected";
  onActionInfoButton: string = null;


  constructor(private lps: LateralPanelService,
              private cs: CommonService,
              private ap: AnalyticsLibraryService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.checked && changes.checked.currentValue) {
      this.state = "selected";
      } else {
      this.state = "deselected";
    }
  }

  ngOnInit() {
  }

  onClickSelector() {
    this.selected.next(this.id);
  }

  onClickInfoRequest() {
    this.infoRequested.next(this.id);
  }

  onHighlightInfoButton(action: string) {
    this.onActionInfoButton = action;
  }

  onInfoClick(event: Event) {
    event.stopPropagation();
    this.ap.sendGAEventWithInfoString("step_2_info", [{ key: 'step_2_info_title', value: this.name }]);
    if (this.lateralPanelId) this.lps.open(this.lateralPanelId);
    else this.infoClicked.next(this.id);
  }

  infoTooltipIsVisible(tooltipType){
    return tooltipType == TooltipTypesEnum.INFO;
  }

  discoverTooltipIsVisible(tooltipType){
    return tooltipType == TooltipTypesEnum.DISCOVER;
  }

  selectTooltipIsVisible(tooltipType){
    return tooltipType == TooltipTypesEnum.SELECT;
  }

}
